import { dateToUTC } from "pro-features/pages/segments/components/benchmarkOvertime/SegmentsVsGroupLineChart";
import * as _ from "lodash";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import markerWithDashedConfig from "pro-features/components/Chart/src/configs/series/markerWithDashedLinePerPointChartConfig";
import { CHART_COLORS } from "app/constants/ChartColors";

export const displayTypeItems = [
    {
        name: "numeric",
        display: "#",
    },
    {
        name: "percentage",
        display: "%",
    },
];

export const NewVsReturningVertical = {
    NewUsers: {
        dataKey: "NewUsers",
        displayText: "New Users",
    },
    ReturningUsers: {
        dataKey: "ReturningUsers",
        displayText: "Returning Users",
    },
};

export const transformData = (data, key, isPercentage?, selectedSites?: Array<string>) => {
    return _.map(Object.keys(NewVsReturningVertical), (chartKey: string, index) => {
        const chartData = data?.[key]?.Graph;
        const color = CHART_COLORS.newReturningUsersColors[chartKey];
        const name = NewVsReturningVertical[chartKey].displayText;
        const baseSeriesConfig: any = {
            name,
            color,
            tooltipIndex: index,
            isSelected: selectedSites.includes(name),
        };
        return combineConfigs(
            {
                ...baseSeriesConfig,
                isDataSingleSeries: true,
                data: Object?.entries(chartData ?? {}).map(([date, dataPoint]) => {
                    if (!dataPoint) {
                        return;
                    }
                    const confidenceLevel = 0.1; //dataPoint?.["Confidence"];
                    let value = isPercentage
                        ? dataPoint?.[chartKey] /
                          (dataPoint?.[NewVsReturningVertical.ReturningUsers.dataKey] +
                              dataPoint?.[NewVsReturningVertical.NewUsers.dataKey])
                        : dataPoint?.[chartKey];
                    if (isNaN(parseFloat(value))) {
                        value = null;
                    }
                    return [
                        dateToUTC(date),
                        value,
                        {
                            partial: confidenceLevel >= 0.3 && confidenceLevel < 1,
                            hallowMarker: confidenceLevel >= 0.3 && confidenceLevel < 1,
                            confidenceLevel,
                        },
                    ];
                }),
            },
            [baseSeriesConfig, markerWithDashedConfig],
        );
    });
};
